<div class="page gray-font-color font-family bodyBackground">
  <div>
    <div class="header-navigation-back">
      <mat-icon (click)="goBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">arrow_back</mat-icon>
      <span class="title">Accident Records</span>
    </div>
    @if (!isContentReady) {
      <div>
        <app-skeleton-accident-traffic-records [isAccidentRecord]="true"></app-skeleton-accident-traffic-records>
      </div>
    }
    @if (isContentReady) {
      <div>
        <div class="accident-question-card">
          <p class="question-label">Have you been involved in any accidents in the last 3 years?</p>
          <div class="radio-with-spinner">
            <mat-radio-group class="accident-radio-group"
              [value]="getAccidentRadioValue()"
              [disabled]="disableNoAccidents || radioSaving"
              (change)="onAccidentRadioChange($event)">
              <mat-radio-button value="yes" data-testid="hasAccident-yes">Yes</mat-radio-button>
              <mat-radio-button value="no" data-testid="noAccident-no">No</mat-radio-button>
            </mat-radio-group>
            @if (radioSaving) {
              <mat-spinner diameter="20" class="radio-spinner"></mat-spinner>
            }
          </div>
        </div>

        @if (getAccidentRadioValue() === 'yes' && !openAccidentForm) {
        <div class="accident-hint-text">
          <p class="hint-label">Please add details of each accident below.</p>
        </div>
        <div class="add-new-container">
          <button
            mat-button
            [disabled]="allowEdit || loading"
            (click)="onAddNewAccidentRecord()"
            data-test="add-accident-record-button"
            data-testid="add-accident-record-button"
            >
            <i class="material-icons">add</i> Add New Accident Record
          </button>
        </div>
        }
        @if (errorMessage) {
          <mat-error class="error padding-left-md">
            {{ errorMessage }}
          </mat-error>
        }
        <div class="content" >
          @if (openAccidentForm) {
            <div class="component-container">
              <form
                id="accidentForm"
                [formGroup]="accidentForm"
                (ngSubmit)="onSubmitAccidentRecord('addNewRecord')"
                >
                
                <!-- Basic Information Section -->
                <div class="form-section">
                  <h3 class="section-title">Accident Details</h3>
                  
                  <div class="form-row">
                    <mat-form-field class="form-field" appearance="outline">
                      <mat-label>Date</mat-label>
                      <input
                        matInput
                        readonly
                        placeholder="Select date"
                        [matDatepicker]="accidentDate"
                        formControlName="accidentDate"
                        [max]="maxDate"
                        (click)="accidentDate.open()"
                        data-testid="date"
                        />
                      <mat-datepicker-toggle matSuffix [for]="accidentDate">
                        <mat-icon matDatepickerToggleIcon data-test="from-date-form-field">calendar_today</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #accidentDate touchUi="true"> </mat-datepicker>
                      @if (accidentForm.get('accidentDate').touched && accidentForm.get('accidentDate').invalid) {
                        <mat-error>
                          {{ getAccidentDateErrorMessage() }}
                        </mat-error>
                      }
                    </mat-form-field>
                    
                    <mat-form-field class="form-field" appearance="outline">
                      <mat-label>Nature of Accident</mat-label>
                      <mat-select formControlName="natureOfAccident" data-test="nature-of-accident-selector" data-testid="nature-of-accident-selector">
                        @for (accident of accidentNatures; track accident) {
                          <mat-option
                            [value]="accident.value"
                            data-test="accident-value"
                            [attr.data-testid]="'NoA-' + accident?.name?.toLowerCase()"
                            >{{ accident.name }}</mat-option
                            >
                          }
                        </mat-select>
                        @if (natureOfAccident.touched && natureOfAccident.invalid) {
                          <mat-error>
                            {{ getNatureOfAccidentErrorMessage() }}
                          </mat-error>
                        }
                    </mat-form-field>
                  </div>
                </div>

                <!-- Impact Information Section -->
                <div class="form-section">
                  <h3 class="section-title">Impact Details</h3>
                  
                  <div class="form-row">
                    <mat-form-field class="form-field" appearance="outline">
                      <mat-label>Number of Fatalities</mat-label>
                      <mat-select formControlName="numOfFatalities" data-test="number-of-fatalities-selector" data-testid="number-of-fatalities-selector">
                        @for (num of numInvolved; track num) {
                          <mat-option value="{{ num }}" data-test="fatalities-value" [attr.data-testid]="'NoF-' + num">{{
                            num
                          }}</mat-option>
                        }
                      </mat-select>
                      @if (numOfFatalities.touched && numOfFatalities.invalid) {
                        <mat-error>
                          {{ getNumOfFatalitiesErrorMessage() }}
                        </mat-error>
                      }
                    </mat-form-field>
                    
                    <mat-form-field class="form-field" appearance="outline">
                      <mat-label>Number of Injuries</mat-label>
                      <mat-select formControlName="numOfInjuries" data-test="number-of-injuries-selector" data-testid="number-of-injuries-selector">
                        @for (num of numInvolved; track num) {
                          <mat-option value="{{ num }}" data-test="injuries-value" [attr.data-testid]="'NoI-' + num">{{
                            num
                          }}</mat-option>
                        }
                      </mat-select>
                      @if (numOfInjuries.touched && numOfInjuries.invalid) {
                        <mat-error>
                          {{ getNumOfInjuriesErrorMessage() }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  
                  <div class="form-row">
                    <mat-form-field class="form-field" appearance="outline">
                      <mat-label>Chemical Spills</mat-label>
                      <mat-select formControlName="chemicalsSpilt" data-test="chemicals-spilt-selector" data-testid="chemicals-spilt-selector">
                        <mat-option value="false" data-test="no-button" data-testid="no-button">No</mat-option>
                        <mat-option value="true" data-testid="yes-button">Yes</mat-option>
                      </mat-select>
                      @if (chemicalsSpilt.touched && chemicalsSpilt.invalid) {
                        <mat-error>
                          {{ getChemicalsSpiltErrorMessage() }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>

                <!-- Additional Information Section -->
                <div class="form-section">
                  <h3 class="section-title">Additional Information</h3>
                  
                  <mat-form-field class="form-field" appearance="outline">
                    <mat-label>Notes (Optional)</mat-label>
                    <textarea 
                      matInput 
                      formControlName="notes" 
                      maxlength="140" 
                      placeholder="Enter any additional notes about the accident"
                      rows="3"
                      data-test="notes-field" 
                      data-testid="notes-field">
                    </textarea>
                    <mat-hint align="end">{{ accidentForm.get('notes').value?.length || 0 }}/140</mat-hint>
                    @if (accidentForm.get('notes').hasError('pattern')) {
                      <mat-error>
                        Invalid characters used.
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                
              </form>
            </div>
          }
            <div class="accident-record-history">
              @for (accident of accidentRecords; track accident) {
                <app-accident-view
                  [model]="accident"
                  (updateAccidentPressed)="onUpdateAccidentPressed($event)"
                  (deleteAccidentPressed)="onDeleteAccidentPressed($event)"
                  class="app-accident-view"
                  >
                </app-accident-view>
              }
            </div>
          </div>
        </div>
      }

    @if (openAccidentForm) {
    <div class="fixed-action-footer">
      <button mat-button class="footer-cancel-btn" (click)="onCancel()" [disabled]="loading">
        Cancel
      </button>
      <button mat-flat-button class="footer-save-btn" form="accidentForm"
        [disabled]="!(accidentForm.dirty && accidentForm.valid) || loading"
        data-test="save-new-record" data-testid="save-new-record">
        Save
      </button>
    </div>
    }
    </div>
  </div>
